/* eslint-env browser */

// Pack da landing/onboarding (layout upgraded_landpage): estilos do design
// system .ril-*/.onb-* + máscaras de formulário públicas.

import "../shared/process/process-stages.css";
import { initializeStageRails } from "../shared/process/stageRail";
import "./landing.css";
import { initLandingForms } from "../landing/forms";

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initLandingForms());
} else {
  initLandingForms();
}
document.addEventListener("DOMContentLoaded", () => initializeStageRails());
document.addEventListener("turbolinks:load", () => initializeStageRails());
if (document.readyState !== "loading") initializeStageRails();
window.addEventListener("resize", () => initializeStageRails());
document.fonts?.ready.then(() => initializeStageRails());
